import React, { useEffect } from 'react';

const Loader = ({isDarkMode, isLoading}) => {

    return (
        <>{isLoading &&
            <div className={`flex justify-center items-center py-10 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-blue-500 mr-3"></div>
                <p>Cargando ...</p>
            </div>}</>
    )
}

export default Loader;